import React from "react";

import { Location } from "types";

const defaultLocation = { lat: 47.590630755857205, lng: 14.269525277405483 }; // Austria

export const useCurrentLocation = () => {
  const [loading, setLoading] = React.useState(false);
  const [current, setCurrent] = React.useState<Location>(defaultLocation);
  const [defaultZoom, setDefaultZoom] = React.useState(15);

  const getCurrentCoordinates = async () => {
    setLoading(true);

    navigator.geolocation.getCurrentPosition(
      (props) => {
        const { latitude, longitude } = props.coords;
        setCurrent({ lat: latitude, lng: longitude });
        setLoading(false);
      },
      () => {
        setDefaultZoom(6);
        setLoading(false);
      }
    );
  };

  React.useEffect(() => {
    void getCurrentCoordinates();
  }, []);

  return { current, loading, defaultZoom } as const;
};
